import type {
	DebtPaymentDto,
	DebtRecordRevamped,
	RevampedDebtRecordDto,
} from '../types/debtOverviewApi.types'

const deleteReasons = ['paid', 'otherOwner', 'unrecognized'] as const

export type DeleteReason = (typeof deleteReasons)[number]

export type DebtItemContext =
	| 'CREATED_BY_MONTHIO'
	| 'CREATED_BY_USER'
	| 'USER_IS_ADDING'

export interface DebtItem {
	id: string
	creditor?: {
		logo: string
		name: string
	}
	context: DebtItemContext
	debtRecords: [RevampedDebtRecordDto, ...RevampedDebtRecordDto[]]
	debtPayment: DebtPaymentDto
}

export function canonicalDebtRecord(debtItem: DebtItem): DebtRecordRevamped {
	return debtItem.debtRecords[0]
}

export interface DebtItemsAndDebtPayments {
	// debtPayment field on each of the DebtItem's
	// Are updates maintained on both debPayments and on each of the items?
	debtItems: DebtItem[]
	debtPayments: DebtPaymentDto[]
}

export const isDebtDeleted = (
	record: DebtRecordRevamped,
): boolean | undefined => record.status && record.status !== 'active'

export const isValidItem = (debtItem: DebtItem): boolean => {
	const { debtRecords, debtPayment, context } = debtItem
	const record = canonicalDebtRecord(debtItem)
	if (isDebtDeleted(record)) {
		return true
	}
	if (context === 'CREATED_BY_USER' && !debtRecords[0].debtType) {
		return false
	}
	if (
		debtRecords.some(
			(dr) => dr.principalAmount == null || dr.principalAmount <= 0,
		)
	) {
		return false
	}
	if (
		typeof debtPayment.paymentAmount !== 'number' ||
		debtPayment.paymentAmount < 0
	) {
		return false
	}
	return true
}
